import twMerge from "@krea/customer-features/utils/tailwind-utils";
import {
  ChangeEvent,
  Children,
  cloneElement,
  isValidElement,
  ReactElement,
  ReactNode,
} from "react";

import { Error } from "@krea/customer-features/shared-components/fields/error";
import { Label } from "@krea/customer-features/shared-components/fields/label";

interface IRadioGroupProps {
  id?: string;
  className?: string;
  label?: ReactNode;
  error?: string;
  disabled?: boolean;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  children: ReactNode;
}

const RadioGroup = ({
  id,
  className,
  label,
  children,
  error,
  disabled,
  name,
  onChange,
}: IRadioGroupProps) => {
  return (
    <div className={className}>
      {label && (
        <Label
          className={twMerge("tw-mb-2", {
            "tw-opacity-60": disabled,
          })}
          htmlFor={id}
        >
          {label}
        </Label>
      )}
      <div className={"tw-list tw-space-y-2"}>
        {Children.map(children, (child) => {
          if (isValidElement(child)) {
            return cloneElement(child as ReactElement<any>, {
              name,
              onChange,
              disabled,
              error,
            });
          }
          return child;
        })}
      </div>
      {error && <Error className="tw-mt-3">{error}</Error>}
    </div>
  );
};

export default RadioGroup;
